import styled from 'styled-components';
export const OverflowWrapper = styled.ul `
  background-color: var(--color-neutral-70);
  box-shadow: var(--shadow-level-6);
  z-index: var(--z-index-700-overlay);
  position: absolute;
  width: 280px;
  top: 64px;
  border-top: 1px solid;
  border-top-color: var(--color-neutral-100);
  list-style: none;
  transition: transform ease var(--transition-duration-3), opacity ease var(--transition-duration-3);
  pointer-events: none;
  scroll-behavior: smooth;
  padding-top: 2px;
  padding-bottom: 2px;
  opacity: 0;

  @media all and (min-width: 840px) {
    border-radius: var(--border-radius-sm);

    &[data-islogged='false'] {
      display: none;
    }

    &[data-fixed='true'] {
      height: calc(100vh - 100%);
    }
  }

  @media all and (max-width: 839px) {
    &:not([data-testab='true']) {
      left: 0;
      transform: translateX(-100%);
      top: 100%;
      height: calc(100vh - 100%);
      border-radius: 0;
      padding-bottom: 50px;
      overflow: hidden;
    }

    &[aria-expanded='true']:not([data-testab='true']) {
      height: calc(100vh - 100%);
      overflow: auto;
    }

    &[data-testab='true'] {
      position: fixed;
      top: 0;
      height: calc(100% - 59px);
      right: 0;
      width: 100%;
      left: 0;
      transform: translateX(-100%);
    }
  }

  &[aria-expanded='true'] {
    opacity: 1;
    pointer-events: all;
    overflow: auto;
    transform: translateX(0);
  }
`;
export const FlyOutItem = styled.li `
  &[data-divider='true'] {
    border-bottom: 1px solid var(--color-neutral-90);
    margin-bottom: var(--spacing-0-5);
  }

  .olx-header__menu-link {
    position: relative;
    width: 100%;
    font-size: var(--font-size-xxs);
    padding: var(--spacing-2);
    justify-content: flex-start;
    display: inline-flex;
    column-gap: 16px;
    color: var(--color-neutral-130);
    cursor: pointer;
    transition: all ease var(--transition-duration-3);
    text-decoration: none;

    &:hover {
      text-decoration: none;
      background: var(--color-neutral-90);
    }

    &:focus {
      transform: scale(0.98);
    }
  }

  &[data-divider='true'] {
    border-bottom: 1px solid var(--color-neutral-90);
    margin-bottom: var(--spacing-0-5);
  }

  .olx-header__menu-arrow {
    display: block;
    position: absolute;
    right: var(--spacing-2);
    top: 50%;
    transform: translateY(-50%);
  }

  &[data-haspos='true']:nth-child(2) {
    display: block;
  }

  @media all and (min-width: 840px) {
    .olx-header__menu-arrow {
      display: none;
    }

    &[data-haspos='true']:nth-child(2) {
      display: none;
    }
  }
`;
export const FlyOutLinkBadge = styled.span `
  display: inline-block;
  margin-left: auto;
  text-transform: uppercase;
`;
